
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Color from "../../utils/colorHelper";
import { draggable } from "../../utils/draggable";

@Component({})
export default class HueSlider extends Vue {
  @Prop({ type: Boolean, default: false }) vertical!: boolean;
  @Prop({ required: true }) color!: Color;

  thumbLeft = 0;
  thumbTop = 0;

  get hueValue() {
    const hue = this.color.get("hue");
    return hue;
  }

  @Watch("hueValue")
  changeColor() {
    this.update();
  }

  handleClick(event: MouseEvent) {
    const thumb = this.$refs.thumb as HTMLElement;
    const target = event.target;

    if (target !== thumb) {
      this.handleDrag(event);
    }
  }

  handleDrag(event: MouseEvent) {
    const rect = this.$el.getBoundingClientRect();
    const thumb = this.$refs.thumb as HTMLElement;
    let hue;
    if (!this.vertical) {
      let left = event.clientX - rect.left;
      left = Math.min(left, rect.width - thumb.offsetWidth / 2);
      left = Math.max(left, thumb.offsetWidth / 2);

      hue = Math.round(
        ((left - thumb.offsetWidth / 2) / (rect.width - thumb.offsetWidth)) *
          360
      );
    } else {
      let top = event.clientY - rect.top;
      top = Math.min(top, rect.height - thumb.offsetHeight / 2);
      top = Math.max(top, thumb.offsetHeight / 2);

      hue = Math.round(
        ((top - thumb.offsetHeight / 2) / (rect.height - thumb.offsetHeight)) *
          360
      );
    }
    this.color.set("hue", hue);
  }

  getThumbLeft() {
    if (this.vertical) return 0;
    const el = this.$el as HTMLElement;
    const hue = this.color.get("hue");

    if (!el) return 0;
    const thumb = this.$refs.thumb as HTMLElement;
    return Math.round((hue * (el.offsetWidth - thumb.offsetWidth / 2)) / 360);
  }

  getThumbTop() {
    if (!this.vertical) return 0;
    const el = this.$el as HTMLElement;
    const hue = this.color.get("hue");

    if (!el) return 0;
    const thumb = this.$refs.thumb as HTMLElement;
    return Math.round((hue * (el.offsetHeight - thumb.offsetHeight / 2)) / 360);
  }

  update() {
    this.thumbLeft = this.getThumbLeft();
    this.thumbTop = this.getThumbTop();
  }

  mounted() {
    const dragConfig = {
      drag: (event: MouseEvent) => {
        this.handleDrag(event);
      },
      end: (event: MouseEvent) => {
        this.handleDrag(event);
      }
    };
    draggable(this.$refs.bar as HTMLElement, dragConfig);
    draggable(this.$refs.thumb as HTMLElement, dragConfig);
    this.update();
  }
}
